import { TArrayQuestion } from "../../../interfaces/quiz";
import img1 from "../../../../img/gallery/historia_palacio/1.png";
import img2 from "../../../../img/quiz/img1.png";
import img3 from "../../../../img/quiz/img2.png";
import img4 from "../../../../img/quiz/img3.png";
import img5 from "../../../../img/quiz/img4.png";

const enQuestions:TArrayQuestion =[
    {
        theme:"Constitution",
        question:"The legislative session lasts for:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Four years"
            },
            {
                ansCode:1,
                text:"Five years"
            },
            {
                ansCode:2,
                text:"Ten years"
            }
        ],
        correct:1
    },
    {
        theme:"Constitution",
        question:"You can attend the plenary meetings from the Session Room:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"any citizen"
            },
            {
                ansCode:1,
                text:"Only citizens or invited individuals"
            },
            {
                ansCode:2,
                text:"Only journalists and parliamentary employees"
            }
        ],
        correct:0
    },
    {
        theme:"Constitution",
        question:"The President of the National Assembly is elected:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"By direct and universal suffrage in legislative elections"
            },
            {
                ansCode:1,
                text:"by the constitutional court"
            },
            {
                ansCode:2,
                text:"By absolute majority of votes of Deputies in effective functions"
            }
        ],
        correct:2
    },
    {
        theme:"Constitution",
        question:"The current constitution was approved in:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1990"
            },
            {
                ansCode:2,
                text:"1992"
            }
        ],
        correct:2
    },
    {
        theme:"Constitution",
        question:"The approval of two motions of censure to the Government, necessarily implies:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"The holding of early elections"
            },
            {
                ansCode:1,
                text:"The resignation of the government"
            },
            {
                ansCode:2,
                text:"The presentation by the Government of a motion of confidence"
            }
        ],
        correct:1
    },
    {
        theme:"Constitution",
        question:"From what age can a citizen run for President of the Republic?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"18 years"
            },
            {
                ansCode:1,
                text:"35 years"
            },
            {
                ansCode:2,
                text:"45 years"
            }
        ],
        correct:1
    },
    {
        theme:"Parliamentary history",
        question:"In which year were Cape Verde's first multiparty elections held?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1981"
            },
            {
                ansCode:2,
                text:"1991"
            }
        ],
        correct:2
    },
    {
        theme:"Parliamentary history",
        question:"Who was the first President of the Assembly of the Republic?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Abílio Duarte"
            },
            {
                ansCode:1,
                text:"Amilcar Spencer Lopes"
            },
            {
                ansCode:2,
                text:"Antonio do Espirito Santo Fonseca"
            }
        ],
        correct:0
    },
    {
        theme:"Parliamentary history",
        question:"What was the date of the inauguration of the Palace of the National Assembly?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"October 8, 1988"
            },
            {
                ansCode:1,
                text:"October 18, 1983"
            },
            {
                ansCode:2,
                text:"October 28, 1985"
            }
        ],
        correct:2
    },
    {
        theme:"Parliament in Pictures",
        question:"In 1975 the first parliamentary session was held in this building. Can you identify the building?",
        image:{
            exist:true,
            src:img1
        },
        answer:[
            {
                ansCode:0,
                text:"City Hall - São Vicente"
            },
            {
                ansCode:1,
                text:"City Hall - Praia"
            },
            {
                ansCode:2,
                text:"City Hall - São Filipe"
            }
        ],
        correct:1
    },
    /*{
        theme:"Parliament in Pictures",
        question:"Who is the author of the following table, offered to the President of the National Assembly in 1998?",
        image:{
            exist:true,
            src:img2
        },
        answer:[
            {
                ansCode:0,
                text:"Bertina Lopes"
            },
            {
                ansCode:1,
                text:"Kiki Lima"
            },
            {
                ansCode:2,
                text:"Pedro Martins"
            }
        ],
        correct:0
    },*/
    {
        theme:"Parliament in Pictures",
        question:"What is the title of this painting made by several Cape Verdean artists to commemorate the 20th anniversary of National Independence?",
        image:{
            exist:true,
            src:img3
        },
        answer:[
            {
                ansCode:0,
                text:"The Creole Mix"
            },
            {
                ansCode:1,
                text:"Cape Verdean daily life"
            },
            {
                ansCode:2,
                text:"The Creole Adventure"
            }
        ],
        correct:2
    },
    {
        theme:"Constitution",
        question:"The National Assembly of Cape Verde is the second organ of national sovereignty, it is responsible for the functions",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Legislative and political oversight"
            },
            {
                ansCode:1,
                text:"Veto or enact laws"
            },
            {
                ansCode:2,
                text:"Executive"
            }
        ],
        correct:0
    },
    {
        theme:"National symbols",
        question:"The current Cape Verdean Anthem was written by",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Norberto Tavares"
            },
            {
                ansCode:1,
                text:"Amílcar Spencer Lopes "
            },
            {
                ansCode:2,
                text:"Abílio Duarte"
            }
        ],
        correct:1
    },
    {
        theme:"Parliament in Pictures",
        question:"What is the name of the figure from Cape Verdean folklore represented in this piece?",
        image:{
            exist:true,
            src:img4
        },
        answer:[
            {
                ansCode:0,
                text:"Chibinho"
            },
            {
                ansCode:1,
                text:"Tia Ganga"
            },
            {
                ansCode:2,
                text:"Blimundo"
            }
        ],
        correct:2
    },
    {
        theme:"Parliament in Pictures",
        question:"This monument represents Cape Verde's friendship with which country?",
        image:{
            exist:true,
            src:img5
        },
        answer:[
            {
                ansCode:0,
                text:"Brasil"
            },
            {
                ansCode:1,
                text:"China"
            },
            {
                ansCode:2,
                text:"Portugal"
            }
        ],
        correct:1
    },
    {
        theme:"Constitution",
        question:"Each Legislative Session is closed with a debate on a very well-known topic, what is it?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"state of the nation"
            },
            {
                ansCode:1,
                text:"State budget"
            },
            {
                ansCode:2,
                text:"State of Justice"
            }
        ],
        correct:0
    },
    {
        theme:"Constitution",
        question:"Under the Rules of Procedure, how many Ordinary Sessions are held each month?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"One"
            },
            {
                ansCode:1,
                text:"Two"
            },
            {
                ansCode:2,
                text:"Three"
            }
        ],
        correct:1
    }
];

export default enQuestions;